export default "__VITE_ASSET__Cipr0SZD__"